module.exports = __webpack_public_path__ + "img/189-equatorial-guinea.2f5039e9.svg";